import React from 'react'
import { DirectPayType, useDirectPayContext } from '../context/DirectPayContext'
import { CheckbookVirtualCard } from '../../../../../graphql/generated/graphql'
import { Body, colors, Margin, Spacer } from '@spritz-finance/ui'
import { formatCurrency } from '../../../../../utils/format'
import styled from 'styled-components'
import { InfoIcon } from './amountInput/PriceBreakdown'
import { FadePresence } from '../../../../../components/FadePresence'

const NewBalanceRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 16px 24px;
    border: 1px solid #efefef;
    box-shadow: 8px 8px 20px rgba(0, 0, 0, 0.08);
    border-radius: 10px;
    align-items: center;
    margin-top: 8px;
    margin-bottom: 24px;
`

const BalancesCaptions = styled.div`
    padding: 0px 16px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 8px;
`

export const BalancesIndicator: React.VFC<{ amount?: number }> = ({ amount }) => {
    const { fullAccount, type } = useDirectPayContext()

    const currentBalance = (fullAccount as CheckbookVirtualCard).balance ?? 0
    const newBalance = Number(amount ?? 0) + currentBalance

    if (type !== DirectPayType.SpritzCard) return null

    return (
        <>
            <BalancesCaptions>
                <Body.Med size={12}>Current Balance</Body.Med>
                <Body.Reg size={12}>New Balance</Body.Reg>
            </BalancesCaptions>
            <NewBalanceRow>
                <Body.Med size={16}>{formatCurrency(currentBalance)}</Body.Med>
                <Body.Bold size={16}>{formatCurrency(newBalance)}</Body.Bold>
            </NewBalanceRow>
        </>
    )
}

const DelayIndicatorWrapper = styled.div`
    padding: ${Margin.Small};
    background-color: var(--surface-3, ${colors.ltAqua[25]});
    border-radius: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
`

export const DelayIndicator: React.VFC<{ isDelayed?: boolean }> = ({ isDelayed }) => {
    return (
        <FadePresence renderKey={isDelayed}>
            {!isDelayed && null}
            {isDelayed && (
                <>
                    <Spacer height={8} />
                    <DelayIndicatorWrapper>
                        <InfoIcon />
                        <Spacer width={16} />
                        <Body.Med size={14}>
                            Funds will be available for use within 1 business day.
                        </Body.Med>
                    </DelayIndicatorWrapper>
                    <Spacer height={16} />
                </>
            )}
        </FadePresence>
    )
}
